import styled from '@emotion/styled';
import { createElement, FC } from 'react';

import { Creation, Deliverable, File, UserOptimizer } from '../../../../generated/graphql';
import { getLatestDeliverable } from '../../../../graphql/creation';
import { SPACING_UNIT } from '../../../constant/spacing';
import { flexibleLayoutContainer } from '../../../styleUtility/flexibleLayout';
import ImageScreen from '../../primitive/ImageScreen';
import PublicId from '../../primitive/PublicId';
import AvatarAndName from '../AvatarAndName';

type Props = {
  thumbnailImageUrl: string;
  creation?:
    | (Pick<Creation, 'id'> & {
        assignee?: Pick<UserOptimizer, 'name' | 'profileImageUrl'> | null | undefined;
        deliverables: Array<
          Pick<Deliverable, 'createdAt'> & {
            creative: {
              file: Pick<File, 'thumbnailUrl'>;
            };
          }
        >;
      })
    | null
    | undefined;
};

const CreativeCard: FC<Props> = ({ thumbnailImageUrl, creation }) => {
  const latestDeliverable = creation && getLatestDeliverable(creation);
  return (
    <Root>
      {thumbnailImageUrl ? (
        <CreativeThumbnail src={thumbnailImageUrl} />
      ) : creation && latestDeliverable && latestDeliverable.creative.file.thumbnailUrl ? (
        <CreativeThumbnail src={latestDeliverable.creative.file.thumbnailUrl} />
      ) : (
        <DummyThumbnail src={'/assets/dummy_thumbnail.svg'} />
      )}
      {creation && (
        <div>
          <PublicId id={creation.id} noWrap />
          {creation.assignee && <AvatarAndName user={creation.assignee} />}
        </div>
      )}
    </Root>
  );
};

const Root = styled('div')({
  ...flexibleLayoutContainer({
    direction: 'row',
    alignItems: 'center',
  }),
});

const CreativeThumbnail = styled(ImageScreen)({
  minWidth: 60,
  maxWidth: 60,
  height: 60,
  marginRight: SPACING_UNIT,
});

const DummyThumbnail = styled(ImageScreen)({
  background: '#fff',
  minWidth: 60,
  maxWidth: 60,
  height: 60,
  marginRight: SPACING_UNIT,
});

export default CreativeCard;
